import React from "react";
import { Card } from "antd";
import "./MyPatients.css";

function MiniPatientCard() {
  return (
    <div>
      <Card className="indv-card">
        <div
          className="row"
          style={{
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
        >
          <img
            src="https://i.pinimg.com/originals/7e/50/a8/7e50a8ec377bd1d6edc3d613edcb17e5.jpg"
            style={{ height: 100, width: 100, borderRadius: 50 }}
            alt="Profile"
          />
        </div>
        <div
          className="row"
          style={{
            fontSize: "2.3rem",
            fontWeight: "bold",
            textAlign: "center",
            marginTop: "1rem",
          }}
        >
          Chirag Dugar
        </div>
        <div
          className="row"
          style={{
            fontSize: "1.6rem",
            textAlign: "center",
          }}
        >
          9874561230
        </div>
        <div
          className="row button-request"
          style={{
            backgroundColor: "#9254DE",
            marginTop: "2rem",
            paddingTop: ".6rem",
            paddingBottom: ".6rem",
            color: "white",
            fontSize: "1.6rem",
            textAlign: "center",
            cursor: "pointer",
          }}
        >
          Request Documents
        </div>
      </Card>
    </div>
  );
}

export default MiniPatientCard;
